import {  useLocation, useParams } from 'react-router-dom'
import { AllowedAccess } from 'react-permission-role'
import { Card, CardContent, Grid } from '@mui/material'

import { useFechInitCasesReceived } from './hooks'

import { LinearLoading } from 'common'

import { LogBook } from './Logbook';
import { ContractExtraExpenses } from './ContractExtraExpenses';
import { ContractsTable } from './ContractsTable'
import { ContractAppliesForm } from './ContractForm'
import { ModalModule } from './ModalModule'

export const LeasesCasesReceived = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitCasesReceived({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,

        // defaultData,
        
        //------------- Actions
        // Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { showForm, showLogBook, showExpenses } = globalStates

    // ------------------------------------------------ Actions
    
    // ------------------------------------------------ FetchData
    const { fetchAllLeaseContracts } = FetchData
    const { loadingFetchLeaseContracts } = fetchAllLeaseContracts

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios

    return (
        <AllowedAccess permissions={['117_ARRENDAMIENTOS_CASOS_RECIBIDOS']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            {!(showForm || showLogBook || showExpenses) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <div className='h4 mt-1 mb-1'> Contratos Arrendamientos</div>
                                <div className="border-bottom border-dark"></div>
                                {loadingFetchLeaseContracts && ( <LinearLoading  /> )}
                                <div className="pt-4"></div>
                                <ContractsTable useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>     
                </Grid>
            )}
            {(showForm) && (
                <ContractAppliesForm useFetchInit={useFetchInit} />
            )}
            {(showLogBook) && (
                <LogBook useFetchInit={useFetchInit} />
            )}
            {(showExpenses) && (
                <ContractExtraExpenses useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}